export function pluralize(unit, num) {
  let str = `${ num } ${ unit }`;
  return num === 1 ? `${ str }` : `${ str }s`;
}

export function relativeTimeString(diffDuration) {
  let str;

  const years = diffDuration.years();
  const months = diffDuration.months();
  const hours = diffDuration.hours();
  const days = diffDuration.days();
  const mins = diffDuration.minutes();
  const secs = diffDuration.seconds();

  if (years >= 1) {
    str = pluralize('year', years);
    //if (months > 0) {
    //  str += `, ${ pluralize('month', months) }`;
    //}
  } else if (months >= 1) {
    str = pluralize('month', months);
    //if (days > 0) {
    //  str += `, ${ pluralize('day', days) }`;
    //}
  } else if (days >= 1) {
    str = pluralize('day', days);
    //if (hours > 0) {
    //  str += `, ${ pluralize('hour', hours) }`;
    //}
  } else if (hours >= 1) {
    str = pluralize('hour', hours);
    if (mins > 0) {
      str += `, ${ pluralize('min', mins) }`;
    }
  } else if (mins >= 1) {
    str = pluralize('min', mins);
  } else {
    str = pluralize('sec', secs);
  }

  return str;
}


// WEBPACK FOOTER //
// ./src/util/date.js